import { render, staticRenderFns } from "./Testpage.vue?vue&type=template&id=e8a61754"
import script from "./Testpage.vue?vue&type=script&lang=js"
export * from "./Testpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports